import React, {useState} from 'react';

import {Button, NumberInput, Text} from '@albert-io/atomic';

import OnboardingPageLayout from '../OnboardingPageLayout';

interface AgeCheckStepProps {
  onSubmit: (age: number) => void;
}

export default function AgeCheckStep({onSubmit}: AgeCheckStepProps) {
  const [age, setAge] = useState('');

  const handleSubmit = () => {
    const ageNum = parseInt(age, 10);
    if (!isNaN(ageNum) && ageNum > 0) {
      onSubmit(ageNum);
    }
  };

  return (
    <OnboardingPageLayout>
      <div className='flex flex-col gap-x0-half'>
        <Text className='text-xxl font-black'>Age Verification</Text>
        <Text>In order to use Albert, we need to know how old you are.</Text>
      </div>

      <div className='px-x1'>
        <NumberInput
          min={0}
          placeholder='Enter your age'
          value={age}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAge(e.target.value)}
          aria-label='Age'
          data-testid='new-age-input'
        />
      </div>

      <Button
        className='w-full'
        color='primary'
        size='l'
        roundness='pill'
        disabled={!age}
        onClick={handleSubmit}
      >
        <Text color='primary-inverse-static'>Submit</Text>
      </Button>
    </OnboardingPageLayout>
  );
}
